module.exports = __webpack_public_path__ + "static/media/fate.9c4343cd.mp3";